import { FC } from 'react'
import ReactWOW from '../ReactWOW/ReactWOW'
import BookDemoButton from '../Start/BookDemoButton'

import msCertifiedApp from "../../assets/svg/mscertifiedapp.svg"
import iso27001_2022 from '../../assets/images/iso/BC Certified logo_ISO 27001-2022 RVA_ENG.png'
import iso27017_2015 from '../../assets/images/iso/BC Certified logo_ISO 27017-2015_ENG.png'
import { ProductList } from './ProductList'
import { Link, Trans, useTranslation } from '../../plugins/i18next/ea-react-i18next'
import { ProductType } from "./ProductList";
import { graphql, useStaticQuery } from 'gatsby'
import { AllFileData } from '../../utils/core'
import { getProductClass } from './KeyFeaturesList'
import Button, { ButtonType } from '../Start/Button'


const ProductBanner: FC<{ product: ProductType }> = ({ product }) => {

  const { t } = useTranslation("components", { keyPrefix: 'products.productsBanner' });

  const productItem = ProductList.find(productItem => productItem.type === product);
  const customLink = productItem?.customLink;
  const productClass = getProductClass(product);

  const data: AllFileData = useStaticQuery(graphql`
    {
      allFile(filter: {extension: {eq: "pdf"}, sourceInstanceName: {eq: "featurelistdownloads"}})
      {
        edges {
          node {
            name
            publicURL
          }
        }
      }
    }
  `);

  const downloadFile = data.allFile.edges.filter((p) => `${p.node.name}.pdf` === t(`productlist.${productClass}.downloadOnePager`) as string)[0];
  const productFeatureListDownload = downloadFile?.node?.publicURL;

  return (
    <div className={`hero-banner product ${product} pt-0 pb-70`}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className={`hero-banner-content ${product}`}>
              <img src={productItem?.Svg} alt="banner images" />
              <ReactWOW delay='.1s' animation='fadeInLeft'>
                <h1>{productItem && (<Trans t={t}>{productItem.title}</Trans>)}</h1>
                {productItem?.msCertifiedLink && (
                  <a href={productItem?.msCertifiedLink} target="_blank"><img id="mscertified" src={msCertifiedApp} alt="Microsoft 365 Certified App" /></a>
                )
                }
              </ReactWOW>
              <ReactWOW delay='.1s' animation='fadeInLeft'>
                <p>
                  {productItem && (<Trans t={t}>{productItem.description}</Trans>)}
                </p>
              </ReactWOW>
              <ReactWOW delay='.1s' animation='fadeInLeft'>
                <div className={`hero-banner-iso ${product}`}>
                  <div className={`iso-image ${product}`}>
                    <img id="iso27001_2022" src={iso27001_2022} alt="Iso 27001-2022" />
                  </div><div className={`iso-image ${product}`}>
                    <img id="iso27017_2015" src={iso27017_2015} alt="Iso 27017_2015" />
                  </div>
                </div>
              </ReactWOW>
              <ReactWOW delay=".1s" animation="fadeInRight">
                <div className="banner-btn">
                    {customLink ? (
                      <a href={customLink} className={`default-btn with-icon productcard ${product}`} target="_blank">
                        <i className="flaticon-right"></i> {<Trans t={t}>{productItem?.customActionButtonText}</Trans>} <span></span>
                      </a>
                    ) : (
                      <BookDemoButton />
                    )}
                  {productItem?.downloadBrochureLink == true && (
                    <Button text={t(`productlist.${productClass}.downloadOnePagerText`)} type={ButtonType.Secondary} href={productFeatureListDownload} icon="flaticon-right" external={true} />
                  )}
                </div>
              </ReactWOW>
            </div>
          </div>

          <div className="col-lg-6 col-md-12 productbannerimg">
            <div className={`main-unicorn ${product}`}>
              <ReactWOW delay='.1s' animation='fadeInRight'>
                <img src={productItem?.HeroImg} alt="features" />
              </ReactWOW>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductBanner